(() => {
  const rootSelector = '[data-etsy-customization-root]';
  const inputSelector = '[data-etsy-customization-input]';
  const fieldSelector = '[data-etsy-customization-field]';
  const groupSelector = '.etsy-customization__group';
  const optionSelector = '[data-option-name]';
  const summarySelector = '[data-etsy-customization-summary]';
  const summaryCountSelector = '[data-etsy-customization-summary-count]';
  const summaryStatusSelector = '[data-etsy-customization-summary-status]';
  const summaryListSelector = '[data-etsy-customization-summary-list]';
  const stickySelector = '[data-etsy-sticky-purchase]';
  const stickyPriceSelector = '[data-etsy-sticky-price]';
  const stickyStatusSelector = '[data-etsy-sticky-status]';
  const stickySubmitSelector = '[data-etsy-sticky-submit]';
  const primarySubmitSelector = '[data-etsy-primary-submit]';
  const referenceToolsSelector = '[data-etsy-reference-tools]';
  const referenceOpenerSelector = '[data-etsy-reference-opener]';
  const variantReferenceToolsSelector = '[data-etsy-variant-reference-tools]';
  const variantReferenceOpenerSelector = '[data-etsy-variant-reference-opener]';
  const filamentReferenceSource = '5545057644_fu3r';
  const filamentReferenceImageUrl =
    'https://cdn.shopify.com/s/files/1/0699/5964/7460/files/il_fullxfull.5545057644_fu3r_5ac68dc2-0be6-47d0-a42c-b76cad67ecc6.jpg?v=1774111222';
  const standardFilamentPalette = [
    'Army Beige',
    'Army Green',
    'Baby Pink',
    'Beige',
    'Black',
    'Black-Orange Dual',
    'Blue-Red Dual',
    'Brown',
    'Burnt Titanium',
    'Coral',
    'Crimson Red Sparkle',
    'Forest Green',
    'Glass Watermelon Red',
    'Glow Blue',
    'Glow Green',
    'Glow Orange',
    'Gold',
    'Gray',
    'IridiumGold Metallic',
    'Light Green',
    'Lime',
    'Mermaid',
    'Navy Blue',
    'Orange',
    'Pastel Rainbow',
    'Pink',
    'Purple',
    'Rainbow',
    'Red',
    'RedGoldBlackGradient',
    'Royal Blue',
    'Silk Red',
    'Sky Blue',
    'Starlight Aurora',
    'Starlight Comet',
    'Starlight Jupiter',
    'Starlight Mercury',
    'Starlight Meteor',
    'Starlight Nebula',
    'Starlight Neptune',
    'Starlight Twilight',
    'Sunrise',
    'Trans BluePurple',
    'Unicorn',
    'Violet',
    'White',
    'Yellow',
    'Ziro Winter',
    'Ziro Wood',
    'iSanmate Rainbow',
  ];

  function decodeHtmlEntities(value) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function parseJsonAttribute(value, fallback) {
    if (!value) {
      return fallback;
    }

    try {
      return JSON.parse(decodeHtmlEntities(value));
    } catch (error) {
      console.error('Unable to parse Etsy customization visibility metadata.', error);
      return fallback;
    }
  }

  function normalizeValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  function normalizeKey(value) {
    return normalizeValue(value)
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function isPrimaryColorLabel(value) {
    return normalizeKey(value).includes('primary-color');
  }

  function getInputValue(input) {
    if (input.type === 'checkbox') {
      return input.checked ? input.value : '';
    }

    return input.value.trim();
  }

  function setFieldValidity(input, isValid) {
    input.toggleAttribute('aria-invalid', !isValid);

    const field = input.closest(fieldSelector);
    if (field) {
      field.classList.toggle('etsy-customization__field--invalid', !isValid);
    }
  }

  function getRequiredInputs(root) {
    return Array.from(root.querySelectorAll(`${inputSelector}[required]`));
  }

  function getVisibleInputs(root) {
    return Array.from(root.querySelectorAll(inputSelector)).filter((input) => {
      const field = input.closest(fieldSelector);
      return field && !field.hidden && !input.disabled;
    });
  }

  function getScope(root) {
    return root.closest('product-info') || root.closest('quick-add-modal') || root.closest('section') || document;
  }

  function getVariantOptionValue(root, optionLabel) {
    if (!optionLabel) {
      return '';
    }

    const scope = getScope(root);
    const optionContainers = Array.from(scope.querySelectorAll(optionSelector));
    const matchingOption = optionContainers.find(
      (container) => normalizeValue(container.dataset.optionName) === normalizeValue(optionLabel)
    );

    if (!matchingOption) {
      return '';
    }

    const select = matchingOption.matches('select') ? matchingOption : matchingOption.querySelector('select');
    if (select instanceof HTMLSelectElement) {
      return select.value.trim();
    }

    const checkedRadio = matchingOption.querySelector('input[type="radio"]:checked');
    return checkedRadio instanceof HTMLInputElement ? checkedRadio.value.trim() : '';
  }

  function getConditionalControlValue(root, condition) {
    const targetField = Array.from(root.querySelectorAll(fieldSelector)).find((field) => {
      return (
        normalizeValue(field.dataset.etsyCustomizationFieldKey) === normalizeValue(condition.option_key) ||
        normalizeValue(field.dataset.etsyCustomizationFieldLabel) === normalizeValue(condition.option_label)
      );
    });

    const targetInput = targetField ? targetField.querySelector(inputSelector) : null;
    if (
      targetInput instanceof HTMLInputElement ||
      targetInput instanceof HTMLSelectElement ||
      targetInput instanceof HTMLTextAreaElement
    ) {
      return getInputValue(targetInput);
    }

    return getVariantOptionValue(root, condition.option_label);
  }

  function getCurrentProductHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getFieldByLabel(root, label) {
    return Array.from(root.querySelectorAll(fieldSelector)).find((field) => {
      return normalizeValue(field.dataset.etsyCustomizationFieldLabel) === normalizeValue(label);
    });
  }

  function getVariantOptionLabels(root) {
    const scope = getScope(root);
    return Array.from(scope.querySelectorAll(optionSelector))
      .map((container) => normalizeValue(container.dataset.optionName))
      .filter(Boolean);
  }

  function buildSelectWrapper(options, selectedValue) {
    const wrapper = document.createElement('div');
    wrapper.className = 'select';

    const select = document.createElement('select');
    select.className = 'select__select';
    select.dataset.etsyCustomizationInput = '';
    select.required = true;

    options.forEach((optionData, index) => {
      const option = document.createElement('option');
      option.value = optionData.value;
      option.textContent = optionData.label;
      if (index === 0 || optionData.value === selectedValue) {
        option.selected = true;
      }
      select.appendChild(option);
    });

    wrapper.appendChild(select);

    const caret = document.createElement('span');
    caret.className = 'icon-caret';
    caret.setAttribute('aria-hidden', 'true');
    wrapper.appendChild(caret);

    return { wrapper, select };
  }

  function upgradeSkullLegacyGemstoneField(root) {
    if (getCurrentProductHandle() !== 'articulated-skull-three-styles-3d-print') {
      return;
    }

    const existingGemstoneField = getFieldByLabel(root, 'Gemstone Color');
    if (existingGemstoneField) {
      return;
    }

    const noteField = getFieldByLabel(root, 'Personalization Note');
    const primaryField = getFieldByLabel(root, 'Primary color');
    const primarySelect = primaryField ? primaryField.querySelector('select') : null;
    if (!(noteField instanceof HTMLElement) || !(primarySelect instanceof HTMLSelectElement)) {
      return;
    }

    const labelText = noteField.querySelector('.etsy-customization__label-text');
    if (labelText instanceof HTMLElement) {
      labelText.textContent = 'Gemstone Color';
    }

    noteField.dataset.etsyCustomizationFieldKey = 'gemstone_color';
    noteField.dataset.etsyCustomizationFieldLabel = 'Gemstone Color';
    noteField.dataset.etsyCustomizationRequired = 'true';
    noteField.dataset.etsyCustomizationVisibility = JSON.stringify([
      {
        type: 'product_option_value',
        option_key: 'style',
        option_label: 'Style',
        match_mode: 'equals_any',
        values: ['Unicorn', 'Punk'],
      },
    ]);

    const help = noteField.querySelector('.etsy-customization__help');
    if (help instanceof HTMLElement) {
      help.textContent = 'Choose the gemstone color for the Unicorn or Punk style.';
    }

    const existingInput =
      noteField.querySelector('textarea, input[type="text"], input[type="number"], input[type="checkbox"], select');
    const selectedValue =
      existingInput instanceof HTMLSelectElement || existingInput instanceof HTMLInputElement
        ? existingInput.value
        : '';

    const options = Array.from(primarySelect.options).map((option) => ({
      value: option.value,
      label: option.textContent || option.value,
    }));
    if (!options.length) {
      return;
    }

    const { wrapper, select } = buildSelectWrapper(options, selectedValue);
    const nextId = `${primarySelect.id || 'product-form'}-gemstone_color`;
    select.id = nextId;
    select.name = 'properties[Gemstone Color]';

    if (existingInput instanceof HTMLElement) {
      const inputContainer =
        existingInput.closest('.field, .select, .etsy-customization__checkbox') || existingInput;
      inputContainer.replaceWith(wrapper);
    } else {
      noteField.appendChild(wrapper);
    }
  }

  function removeRatLegacyNoteField(root) {
    if (getCurrentProductHandle() !== 'cute-rat-flexi-articulated-3d-print') {
      return;
    }

    const noteField = getFieldByLabel(root, 'Personalization Note');
    const eyesField = getFieldByLabel(root, 'Eyes Color');
    const earsNoseField = getFieldByLabel(root, 'Ears/Nose Color');
    if (noteField && eyesField && earsNoseField) {
      noteField.remove();
    }
  }

  function removeCupidCowLegacyNoteField(root) {
    if (getCurrentProductHandle() !== 'articulated-cute-cupid-cow-flexi-3d-print') {
      return;
    }

    const noteField = getFieldByLabel(root, 'Personalization Note');
    const eyesField = getFieldByLabel(root, 'Eyes Color');
    const wingsHornsField = getFieldByLabel(root, 'Wings/Horns Color');
    const heartHoovesFurField = getFieldByLabel(root, 'Heart/Hooves/Fur Color');
    if (noteField && eyesField && wingsHornsField && heartHoovesFurField) {
      noteField.remove();
    }
  }

  function removeMancalaLegacyGamePieceField(root) {
    if (getCurrentProductHandle() !== 'dragon-fantasy-mancala-game-set-3d-printed') {
      return;
    }

    const gamePieceField = getFieldByLabel(root, 'Game Piece Selection');
    if (gamePieceField) {
      gamePieceField.remove();
    }
  }

  function removeDragonPawLegacyPrimaryColorOption(root) {
    if (getCurrentProductHandle() !== 'dragon-paw-coaster-holder-with-four-dragon-themed-coasters-3d-print') {
      return;
    }

    const scope = getScope(root);
    const primaryColorOption = Array.from(scope.querySelectorAll(optionSelector)).find(
      (option) => normalizeValue(option.dataset.optionName) === 'primary color',
    );

    if (primaryColorOption) {
      const variantPicker = primaryColorOption.closest('variant-selects, variant-radios');
      primaryColorOption.remove();

      if (variantPicker && !variantPicker.querySelector(optionSelector)) {
        variantPicker.remove();
      }
    }
  }

  function removeDuplicateVariantOptionFields(root) {
    const variantOptionLabels = new Set(getVariantOptionLabels(root));
    if (!variantOptionLabels.size) {
      return;
    }

    Array.from(root.querySelectorAll(fieldSelector)).forEach((field) => {
      const label = normalizeValue(field.dataset.etsyCustomizationFieldLabel);
      if (label && variantOptionLabels.has(label)) {
        field.remove();
      }
    });
  }

  function upgradeMothmanLegacyColorFields(root) {
    if (getCurrentProductHandle() !== 'mothman-articulated-3d-print') {
      return;
    }

    const fieldsToUpgrade = [
      'Circles/Eyes Color',
      'Details/Fur on Chest Color',
      'Fur Color',
    ];
    const options = [{ value: '', label: 'Select a color' }].concat(
      standardFilamentPalette.map((value) => ({ value, label: value }))
    );

    fieldsToUpgrade.forEach((label) => {
      const field = getFieldByLabel(root, label);
      if (!(field instanceof HTMLElement)) {
        return;
      }

      const existingSelect = field.querySelector('select');
      if (existingSelect instanceof HTMLSelectElement) {
        return;
      }

      const existingInput =
        field.querySelector('textarea, input[type="text"], input[type="number"], input[type="checkbox"], select');
      const selectedValue =
        existingInput instanceof HTMLInputElement || existingInput instanceof HTMLTextAreaElement
          ? existingInput.value.trim()
          : '';

      const { wrapper, select } = buildSelectWrapper(options, selectedValue);
      select.required = field.dataset.etsyCustomizationRequired === 'true';
      select.name = `properties[${field.dataset.etsyCustomizationFieldLabel || label}]`;
      select.id = existingInput && existingInput.id ? existingInput.id : `${label}-select`;

      if (existingInput instanceof HTMLElement) {
        const inputContainer =
          existingInput.closest('.field, .select, .etsy-customization__checkbox') || existingInput;
        inputContainer.replaceWith(wrapper);
      } else {
        field.appendChild(wrapper);
      }
    });
  }

  function upgradeTinyBabyChameleonLegacyFields(root) {
    if (getCurrentProductHandle() !== 'tiny-baby-chameleon-articulated-3d-print') {
      return;
    }

    const noteField = getFieldByLabel(root, 'Personalization Note');
    const eyesField = getFieldByLabel(root, 'Eyes Color');
    if (!(eyesField instanceof HTMLElement)) {
      return;
    }

    const existingSelect = eyesField.querySelector('select');
    if (!(existingSelect instanceof HTMLSelectElement)) {
      const options = [{ value: '', label: 'Select a color' }].concat(
        standardFilamentPalette.map((value) => ({ value, label: value }))
      );
      const existingInput =
        eyesField.querySelector('textarea, input[type="text"], input[type="number"], input[type="checkbox"], select');
      const selectedValue =
        existingInput instanceof HTMLInputElement || existingInput instanceof HTMLTextAreaElement
          ? existingInput.value.trim()
          : '';

      const { wrapper, select } = buildSelectWrapper(options, selectedValue);
      select.required = eyesField.dataset.etsyCustomizationRequired === 'true';
      select.name = `properties[${eyesField.dataset.etsyCustomizationFieldLabel || 'Eyes Color'}]`;
      select.id = existingInput && existingInput.id ? existingInput.id : 'eyes-color-select';

      if (existingInput instanceof HTMLElement) {
        const inputContainer =
          existingInput.closest('.field, .select, .etsy-customization__checkbox') || existingInput;
        inputContainer.replaceWith(wrapper);
      } else {
        eyesField.appendChild(wrapper);
      }
    }

    if (noteField) {
      noteField.remove();
    }
  }

  function applyLegacyProductFieldFixes(root) {
    if (!(root instanceof HTMLElement)) {
      return;
    }

    removeDuplicateVariantOptionFields(root);
    removeMancalaLegacyGamePieceField(root);
    removeDragonPawLegacyPrimaryColorOption(root);
    upgradeSkullLegacyGemstoneField(root);
    upgradeMothmanLegacyColorFields(root);
    upgradeTinyBabyChameleonLegacyFields(root);
    removeRatLegacyNoteField(root);
    removeCupidCowLegacyNoteField(root);
  }

  function conditionMatches(root, condition) {
    const currentValue = normalizeValue(getConditionalControlValue(root, condition));
    if (!currentValue) {
      return false;
    }

    const values = Array.isArray(condition.values) ? condition.values.map(normalizeValue) : [];
    const matchMode = condition.match_mode || 'equals_any';

    if (!values.length) {
      return true;
    }

    if (matchMode === 'contains_any') {
      return values.some((value) => currentValue.includes(value));
    }

    return values.includes(currentValue);
  }

  function syncConditionalFieldState(root, field) {
    const visibilityConditions = parseJsonAttribute(field.dataset.etsyCustomizationVisibility, []);
    const isVisible =
      visibilityConditions.length === 0 || visibilityConditions.every((condition) => conditionMatches(root, condition));
    const fieldInputs = Array.from(field.querySelectorAll(inputSelector));

    field.hidden = !isVisible;

    fieldInputs.forEach((input) => {
      if (!input.dataset.etsyCustomizationInitiallyRequired) {
        input.dataset.etsyCustomizationInitiallyRequired = input.hasAttribute('required') ? 'true' : 'false';
      }

      input.disabled = !isVisible;
      if (isVisible && input.dataset.etsyCustomizationInitiallyRequired === 'true') {
        input.setAttribute('required', '');
      } else {
        input.removeAttribute('required');
      }

      if (!isVisible) {
        setFieldValidity(input, true);
      }
    });
  }

  function syncGroupVisibility(root) {
    let visibleFieldCount = 0;

    root.querySelectorAll(groupSelector).forEach((group) => {
      const visibleFields = Array.from(group.querySelectorAll(fieldSelector)).filter((field) => !field.hidden);
      group.hidden = visibleFields.length === 0;
      visibleFieldCount += visibleFields.length;
    });

    root.hidden = visibleFieldCount === 0;
  }

  function validateRoot(root) {
    const requiredInputs = getRequiredInputs(root);
    let firstInvalid = null;

    requiredInputs.forEach((input) => {
      const isValid = getInputValue(input) !== '';
      setFieldValidity(input, isValid);
      if (!isValid && !firstInvalid) {
        firstInvalid = input;
      }
    });

    return {
      valid: firstInvalid === null,
      firstInvalid,
    };
  }

  function hasAllRequiredValues(root) {
    return getRequiredInputs(root).every((input) => getInputValue(input) !== '');
  }

  function setErrorMessage(form, message) {
    const productForm = form.closest('product-form');
    const wrapper = productForm ? productForm.querySelector('.product-form__error-message-wrapper') : null;
    const messageNode = wrapper ? wrapper.querySelector('.product-form__error-message') : null;

    if (!wrapper || !messageNode) {
      return;
    }

    if (message) {
      messageNode.textContent = message;
      wrapper.removeAttribute('hidden');
    } else {
      messageNode.textContent = '';
      wrapper.setAttribute('hidden', '');
    }
  }

  function focusInvalidInput(input) {
    if (!input) {
      return;
    }

    input.focus();
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });

    if (typeof input.reportValidity === 'function') {
      input.reportValidity();
    }
  }

  function getVariantSelections(root) {
    const scope = getScope(root);
    return Array.from(scope.querySelectorAll(optionSelector))
      .map((container) => {
        const label = String(container.dataset.optionName || '').trim();
        if (!label) {
          return null;
        }

        const select = container.matches('select') ? container : container.querySelector('select');
        if (select instanceof HTMLSelectElement) {
          return { label, value: select.value.trim() };
        }

        const checkedRadio = container.querySelector('input[type="radio"]:checked');
        return {
          label,
          value: checkedRadio instanceof HTMLInputElement ? checkedRadio.value.trim() : '',
        };
      })
      .filter((entry) => entry && entry.value);
  }

  function getCustomizationSelections(root) {
    return getVisibleInputs(root)
      .map((input) => {
        const field = input.closest(fieldSelector);
        if (!field) {
          return null;
        }

        const value = getInputValue(input);
        if (!value) {
          return null;
        }

        return {
          label: field.dataset.etsyCustomizationFieldLabel || '',
          value,
        };
      })
      .filter(Boolean);
  }

  function getMissingRequiredFields(root) {
    return getRequiredInputs(root)
      .filter((input) => getInputValue(input) === '')
      .map((input) => input.closest(fieldSelector))
      .filter(Boolean);
  }

  function renderSelectionSummary(root) {
    const summary = root.querySelector(summarySelector);
    if (!summary) {
      return;
    }

    const countNode = summary.querySelector(summaryCountSelector);
    const statusNode = summary.querySelector(summaryStatusSelector);
    const listNode = summary.querySelector(summaryListSelector);
    if (!countNode || !statusNode || !listNode) {
      return;
    }

    const variantSelections = getVariantSelections(root);
    const customizationSelections = getCustomizationSelections(root);
    const combinedSelections = [...variantSelections, ...customizationSelections];
    const missingFields = getMissingRequiredFields(root);

    if (missingFields.length > 0) {
      statusNode.textContent = `${missingFields.length} required selection${missingFields.length === 1 ? '' : 's'} left`;
      countNode.textContent = `Complete the required fields marked in red to unlock a clean add-to-cart flow.`;
    } else if (combinedSelections.length > 0) {
      statusNode.textContent = 'Ready to add to cart';
      countNode.textContent = `Your current selections will be saved with this item in the cart.`;
    } else {
      statusNode.textContent = 'Choose your options to continue';
      countNode.textContent = 'Make your selections below and we will summarize them here.';
    }

    listNode.innerHTML = '';

    const itemsToRender = combinedSelections.length
      ? combinedSelections
      : [{ label: 'Selections', value: 'No choices picked yet' }];

    itemsToRender.forEach((item) => {
      const listItem = document.createElement('li');
      listItem.className = 'etsy-customization__summary-item';

      const label = document.createElement('span');
      label.className = 'etsy-customization__summary-label';
      label.textContent = item.label;

      const value = document.createElement('span');
      value.className = 'etsy-customization__summary-value';
      value.textContent = item.value;

      listItem.append(label, value);
      listNode.appendChild(listItem);
    });

    summary.hidden = false;
  }

  function isNodeVisible(node) {
    if (!node) {
      return false;
    }

    if (node.offsetParent !== null) {
      return true;
    }

    const styles = window.getComputedStyle(node);
    return styles.position === 'fixed' && styles.visibility !== 'hidden' && styles.display !== 'none';
  }

  function getDisplayedPriceText(root) {
    const scope = getScope(root);
    const selectors = [
      '.price__sale .price-item--sale',
      '.price__sale .price-item--last',
      '.price__regular .price-item--regular',
      '.price-item--sale',
      '.price-item--regular',
    ];

    for (const selector of selectors) {
      const node = Array.from(scope.querySelectorAll(selector)).find((candidate) => {
        return isNodeVisible(candidate) && candidate.textContent.trim();
      });
      if (node) {
        return node.textContent.replace(/\s+/g, ' ').trim();
      }
    }

    return '';
  }

  function getReferenceGallery(root) {
    const scope = getScope(root);
    return scope.querySelector('media-gallery');
  }

  function scopeHasReferenceImage(root, sourceToken) {
    if (!sourceToken) {
      return false;
    }

    const gallery = getReferenceGallery(root);
    if (!gallery) {
      return false;
    }

    return Array.from(gallery.querySelectorAll('img')).some((image) => {
      const source = image.currentSrc || image.src || '';
      return source.includes(sourceToken);
    });
  }

  function scopeHasPrimaryColorControl(root) {
    const scope = getScope(root);
    const hasPrimaryVariantOption = Array.from(scope.querySelectorAll(optionSelector)).some((container) =>
      isPrimaryColorLabel(container.dataset.optionName)
    );

    if (hasPrimaryVariantOption) {
      return true;
    }

    return Array.from(scope.querySelectorAll(fieldSelector)).some((field) => {
      return (
        isPrimaryColorLabel(field.dataset.etsyCustomizationFieldKey) ||
        isPrimaryColorLabel(field.dataset.etsyCustomizationFieldLabel)
      );
    });
  }

  function shouldShowReference(root, sourceToken) {
    if (sourceToken === filamentReferenceSource) {
      return scopeHasPrimaryColorControl(root) || scopeHasReferenceImage(root, sourceToken);
    }

    return scopeHasReferenceImage(root, sourceToken);
  }

  function createVariantReferenceTools(modalId) {
    const tools = document.createElement('div');
    tools.className = 'etsy-customization__reference-tools';
    tools.dataset.etsyVariantReferenceTools = '';
    tools.dataset.etsyGeneratedVariantReference = 'true';
    tools.hidden = true;
    tools.innerHTML = `
      <modal-opener
        class="etsy-customization__reference-opener"
        data-modal="#${modalId}"
        data-etsy-variant-reference-opener
        data-etsy-reference-source="${filamentReferenceSource}"
        hidden
      >
        <button
          type="button"
          class="etsy-customization__reference-link"
          aria-haspopup="dialog"
        >
          View filament colors
        </button>
      </modal-opener>
    `;
    return tools;
  }

  function createVariantReferenceModal(modalId) {
    const modal = document.createElement('modal-dialog');
    modal.id = modalId;
    modal.className = 'product-popup-modal etsy-reference-modal';
    modal.innerHTML = `
      <div
        role="dialog"
        aria-label="Available filament colors"
        aria-modal="true"
        class="product-popup-modal__content etsy-reference-modal__content"
        tabindex="-1"
      >
        <button
          type="button"
          class="product-popup-modal__toggle"
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">
            <path d="M.865 15.978a.5.5 0 0 0 .707.707l7.404-7.404 7.403 7.404a.5.5 0 0 0 .708-.707L9.683 8.573 17.087 1.17a.5.5 0 0 0-.708-.708L8.976 7.866 1.572.462A.5.5 0 1 0 .865 1.17l7.403 7.404z" fill="currentColor"></path>
          </svg>
        </button>
        <div class="product-popup-modal__content-info etsy-reference-modal__panel">
          <div class="etsy-reference-modal__copy-block">
            <p class="etsy-customization__eyebrow">Reference guide</p>
            <h2 class="h2 etsy-reference-modal__title">Available filament colors</h2>
            <p class="etsy-reference-modal__copy">
              Use this chart while choosing your colors. Finished prints can vary a little depending on the filament batch,
              screen brightness, and how the gradient lands during printing.
            </p>
            <ul class="etsy-reference-modal__tips" role="list">
              <li>Most made-to-order listings can use these shared filament colors.</li>
              <li>Gradient, rainbow, glow, and silk filaments can look slightly different from item to item.</li>
              <li>If you want help matching parts to colors, leave a note with your order details.</li>
            </ul>
          </div>
          <div class="etsy-reference-modal__media-card">
            <img
              class="etsy-reference-modal__image"
              src="${filamentReferenceImageUrl}"
              alt="Available filament colors chart"
              loading="lazy"
              width="2700"
              height="2025"
            >
          </div>
        </div>
      </div>
    `;
    return modal;
  }

  function ensureVariantReferenceTools(scope = document) {
    const containers = scope.matches?.('product-info, quick-add-modal')
      ? [scope]
      : Array.from(scope.querySelectorAll ? scope.querySelectorAll('product-info, quick-add-modal') : []);

    containers.forEach((container, index) => {
      if (container.querySelector(referenceToolsSelector) || container.querySelector(variantReferenceToolsSelector)) {
        return;
      }

      const primaryColorOptions = Array.from(container.querySelectorAll(optionSelector)).filter((optionContainer) =>
        isPrimaryColorLabel(optionContainer.dataset.optionName)
      );
      if (!primaryColorOptions.length) {
        return;
      }

      const modalIdBase = container.dataset.productId || container.dataset.section || container.id || `scope-${index}`;
      const modalId = `VariantReferenceDynamic-${normalizeKey(modalIdBase)}-filament`;
      if (!document.getElementById(modalId)) {
        const variantSelects = container.querySelector('variant-selects');
        const modal = createVariantReferenceModal(modalId);
        if (variantSelects && variantSelects.parentNode) {
          variantSelects.insertAdjacentElement('afterend', modal);
        } else {
          container.append(modal);
        }
      }

      primaryColorOptions.forEach((optionContainer) => {
        const nextElement = optionContainer.nextElementSibling;
        if (
          nextElement &&
          nextElement.matches(variantReferenceToolsSelector) &&
          nextElement.dataset.etsyGeneratedVariantReference === 'true'
        ) {
          return;
        }

        optionContainer.insertAdjacentElement('afterend', createVariantReferenceTools(modalId));
      });
    });
  }

  function syncReferenceTools(root) {
    const tools = root.querySelector(referenceToolsSelector);
    if (!tools) {
      return;
    }

    let visibleCount = 0;
    tools.querySelectorAll(referenceOpenerSelector).forEach((opener) => {
      const shouldShow = shouldShowReference(root, opener.dataset.etsyReferenceSource);
      opener.hidden = !shouldShow;
      if (shouldShow) {
        visibleCount += 1;
      }
    });

    tools.hidden = visibleCount === 0;
  }

  function syncVariantReferenceTools(scope = document) {
    ensureVariantReferenceTools(scope);

    const containers = scope.matches?.(variantReferenceToolsSelector)
      ? [scope]
      : Array.from(scope.querySelectorAll ? scope.querySelectorAll(variantReferenceToolsSelector) : []);

    containers.forEach((tools) => {
      let visibleCount = 0;
      tools.querySelectorAll(variantReferenceOpenerSelector).forEach((opener) => {
        const shouldShow = shouldShowReference(tools, opener.dataset.etsyReferenceSource);
        opener.hidden = !shouldShow;
        if (shouldShow) {
          visibleCount += 1;
        }
      });
      tools.hidden = visibleCount === 0;
    });
  }

  function syncStickyPurchase(root) {
    const form = root.closest('form');
    const sticky = form ? form.querySelector(stickySelector) : null;
    const submitButton = form ? form.querySelector(primarySubmitSelector) : null;
    if (!sticky || !submitButton) {
      return;
    }

    if (root.closest('quick-add-modal')) {
      sticky.hidden = true;
      return;
    }

    const priceNode = sticky.querySelector(stickyPriceSelector);
    const statusNode = sticky.querySelector(stickyStatusSelector);
    const stickyButton = sticky.querySelector(stickySubmitSelector);
    const missingFields = getMissingRequiredFields(root);
    const priceText = getDisplayedPriceText(root);
    const submitLabel = submitButton.textContent.replace(/\s+/g, ' ').trim();
    const submitRect = submitButton.getBoundingClientRect();
    const submitVisible = submitRect.bottom > 32 && submitRect.top < window.innerHeight - 32;

    if (priceNode) {
      priceNode.textContent = priceText || submitLabel;
    }

    if (stickyButton) {
      stickyButton.textContent = missingFields.length > 0 ? 'Finish selections' : submitLabel;
      stickyButton.disabled = submitButton.disabled && missingFields.length === 0;
    }

    if (statusNode) {
      if (missingFields.length > 0) {
        statusNode.textContent = `${missingFields.length} required field${missingFields.length === 1 ? '' : 's'} still need attention.`;
      } else if (submitButton.disabled) {
        statusNode.textContent = 'This item is currently unavailable.';
      } else {
        statusNode.textContent = 'Selections are ready. Add to cart from anywhere on the page.';
      }
    }

    sticky.hidden = submitVisible || root.hidden;
  }

  function syncRootState(root) {
    applyLegacyProductFieldFixes(root);

    root.querySelectorAll(`${fieldSelector}[data-etsy-customization-visibility]`).forEach((field) => {
      syncConditionalFieldState(root, field);
    });

    syncGroupVisibility(root);

    const form = root.closest('form');
    if (form && hasAllRequiredValues(root)) {
      setErrorMessage(form, '');
    }

    syncReferenceTools(root);
    renderSelectionSummary(root);
    syncStickyPurchase(root);
  }

  function syncConditionalFields(scope = document) {
    const roots = scope.matches?.(rootSelector)
      ? [scope]
      : Array.from(scope.querySelectorAll ? scope.querySelectorAll(rootSelector) : []);

    roots.forEach((root) => {
      syncRootState(root);
    });

    syncVariantReferenceTools(scope);
  }

  function shouldResyncForNode(node) {
    if (!(node instanceof HTMLElement)) {
      return false;
    }

    const syncSelectors = `${rootSelector}, ${optionSelector}, variant-selects, product-info, quick-add-modal`;
    return node.matches(syncSelectors) || Boolean(node.querySelector(syncSelectors));
  }

  function startSyncObserver() {
    if (!(document.body instanceof HTMLElement)) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type !== 'childList') {
          continue;
        }

        if (shouldResyncForNode(mutation.target)) {
          scheduleViewportSync();
          return;
        }

        for (const node of mutation.addedNodes) {
          if (shouldResyncForNode(node)) {
            scheduleViewportSync();
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function scheduleFollowUpSyncs(scope = document) {
    window.setTimeout(() => syncConditionalFields(scope), 1200);
    window.setTimeout(() => syncConditionalFields(scope), 3000);
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) {
        return;
      }

      if (!form.matches('[data-type="add-to-cart-form"]')) {
        return;
      }

      const root = form.querySelector(rootSelector);
      if (!root) {
        return;
      }

      syncRootState(root);

      const validation = validateRoot(root);
      if (validation.valid) {
        setErrorMessage(form, '');
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      setErrorMessage(
        form,
        root.dataset.requiredMessage ||
          'Please complete the required customization fields before adding this item to your cart.'
      );
      focusInvalidInput(validation.firstInvalid);
    },
    true
  );

  function handleInputEvent(event) {
    const input = event.target;
    if (!(input instanceof HTMLElement) || !input.matches(inputSelector)) {
      return;
    }

    const isValid = !input.hasAttribute('required') || getInputValue(input) !== '';
    setFieldValidity(input, isValid);

    const root = input.closest(rootSelector);
    const form = input.closest('form');
    if (!root || !form) {
      return;
    }

    syncRootState(root);

    if (hasAllRequiredValues(root)) {
      setErrorMessage(form, '');
    }
  }

  document.addEventListener('input', handleInputEvent);
  document.addEventListener('change', handleInputEvent);
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement) || !target.closest('variant-selects')) {
      return;
    }

    requestAnimationFrame(() => {
      syncConditionalFields(target.closest('product-info') || document);
    });
  });

  document.addEventListener('click', (event) => {
    const button = event.target instanceof HTMLElement ? event.target.closest(stickySubmitSelector) : null;
    if (!(button instanceof HTMLElement)) {
      return;
    }

    const form = button.closest('form');
    const root = form ? form.querySelector(rootSelector) : null;
    const submitButton = form ? form.querySelector(primarySubmitSelector) : null;
    if (!root || !submitButton) {
      return;
    }

    syncRootState(root);
    const validation = validateRoot(root);

    if (!validation.valid) {
      setErrorMessage(
        form,
        root.dataset.requiredMessage ||
          'Please complete the required customization fields before adding this item to your cart.'
      );
      focusInvalidInput(validation.firstInvalid);
      return;
    }

    setErrorMessage(form, '');
    submitButton.click();
  });

  document.addEventListener('product-info:loaded', (event) => {
    if (!(event.target instanceof HTMLElement)) {
      return;
    }

    syncConditionalFields(event.target);
    scheduleFollowUpSyncs(event.target);
  });

  let syncScheduled = false;
  function scheduleViewportSync() {
    if (syncScheduled) {
      return;
    }

    syncScheduled = true;
    requestAnimationFrame(() => {
      syncScheduled = false;
      syncConditionalFields(document);
    });
  }

  window.addEventListener('scroll', scheduleViewportSync, { passive: true });
  window.addEventListener('resize', scheduleViewportSync);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        startSyncObserver();
        syncConditionalFields(document);
        scheduleFollowUpSyncs(document);
      },
      { once: true }
    );
  } else {
    startSyncObserver();
    syncConditionalFields(document);
    scheduleFollowUpSyncs(document);
  }
})();
